import { render } from "./ModalDetalleVentas.vue?vue&type=template&id=22101e1c&scoped=true"
import script from "./ModalDetalleVentas.vue?vue&type=script&lang=js"
export * from "./ModalDetalleVentas.vue?vue&type=script&lang=js"

import "./ModalDetalleVentas.vue?vue&type=style&index=0&id=22101e1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22101e1c"]])

export default __exports__